<!DOCTYPE html>
<ion-content>
  <div class="main-container">
    <ion-row class="main-header">
      <ion-col class="heading-wrap ion-no-padding" size="1">
      <p class="back-link ion-margin-top ion-no-margin" (click)="goBack()"> 
      <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.17424 7H18.05C18.5747 7 19 7.44772 19 8C19 8.55229 18.5747 9 18.05 9H3.17421L7.75926 14.3492C8.11868 14.7686 8.07012 15.3999 7.65079 15.7593C7.23147 16.1187 6.60017 16.0701 6.24074 15.6508L0.340136 8.76677C0.132211 8.58333 0 8.30792 0 8C0 7.69202 0.132264 7.41656 0.340263 7.23312L6.24074 0.349227C6.60017 -0.0700991 7.23147 -0.118661 7.65079 0.240762C8.07012 0.600184 8.11868 1.23148 7.75926 1.65081L3.17424 7Z" fill="black"/>
        </svg>
      </p>
      </ion-col>
      <ion-col class="notification-wrap ion-no-padding" size="11">
      </ion-col>
    </ion-row>
    <div class="links-card">
      <ion-card no-lines>
        <p><strong>{{ 'help-confirmation.need_help_title' | translate }}</strong>  
          {{ 'help-confirmation.need_help_subtitle' | translate }}</p>
        <div class="btn-wrapper">
          <button type="button" (click)="goToGetHelpPage()">{{ 'help-confirmation.get_help' | translate }}</button>
        </div>
      </ion-card>
      <ion-card no-lines>
        <div [innerHTML]="'close-confirmation.description' | translate | safeHtml"></div>

       <p class="info"><strong> {{ 'close-confirmation.info' | translate }}</strong></p>
       <div class="checkbox-wrapper">
        <div> <ion-checkbox [class.alert-checkbox]="errorAlert" (ionChange)="onCheck($event)"></ion-checkbox> </div>
        <p>{{ 'close-confirmation.acceptance_details' | translate }}</p>
       </div>
       <div class="red-link"> <p (click)="onClose()">{{ 'close-confirmation.close_account' | translate }}</p>
      </div>
      </ion-card>
      <div class="footer-text"> 
        <p>{{ 'close-confirmation.footer_text' | translate }} <br/> <a (click)="goToDeleteAccountPage()" class="link">{{ 'LOGINPAGE.Click here' | translate }}</a></p>
      </div>
    </div>
  </div> 
</ion-content>
